import ChessRestClient from '@/Api/ChessRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useManageSubscriptionApi(
  handleOnSuccess,
  handleOnError,
) {
  const mutation = useMutation({
    mutationFn: async details => {
      // Extract API password from details and set it in headers
      const apiPassword = details.apiPassword;

      // Remove apiPassword from the payload before sending
      const {apiPassword: _, ...payloadWithoutPassword} = details;

      // Configure headers with the API password
      const headers = {};
      if (apiPassword) {
        headers['API-Password'] = apiPassword;
      }

      if (details.bulk) {
        // For bulk subscriptions, call the same API in a loop
        const results = [];
        const errors = [];

        // Process each mobile number in a loop
        for (const mobileNumber of details.mobile_numbers) {
          try {
            const response = await ChessRestClient.post(
              'subscription/v1/subscribe',
              {
                mobile_number: mobileNumber,
                subscription_plan_id: details.subscription_plan_id,
                ...(details.custom_months && {
                  custom_months: details.custom_months,
                }),
                ...(details.custom_start_date && {
                  custom_start_date: details.custom_start_date,
                }),
              },
              {headers}, // Pass headers with API password
            );

            results.push({
              mobile_number: mobileNumber,
              success: true,
              data: response.data,
            });
          } catch (error) {
            errors.push({
              mobile_number: mobileNumber,
              success: false,
              error: error,
            });
          }
        }

        return {
          results,
          errors,
          totalProcessed: details.mobile_numbers.length,
          successCount: results.length,
          errorCount: errors.length,
        };
      } else {
        // For single subscription
        const response = await ChessRestClient.post(
          'subscription/v1/subscribe',
          {
            mobile_number: details.mobile_number,
            subscription_plan_id: details.subscription_plan_id,
            ...(details.custom_months && {
              custom_months: details.custom_months,
            }),
            ...(details.custom_start_date && {
              custom_start_date: details.custom_start_date,
            }),
          },
          {headers}, // Pass headers with API password
        );
        return response.data;
      }
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return {
    ...mutation,
  };
}
